import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';

interface IndustryLink {
  name: string;
  path: string;
  icon:string;
}

@Component({
  selector: 'app-explore-more-industries',
  standalone: true, // This MUST be true
  imports: [CommonModule, RouterModule],
  templateUrl: './explore-more-industries.component.html',
  styleUrl: './explore-more-industries.component.scss'
})
export class ExploreMoreIndustriesComponent implements OnInit, OnDestroy {
  
  // Note: Adjust the 'path' if your routing is set up differently (e.g., if children are lazy loaded)
  allIndustries: IndustryLink[] = [
    { name: 'Healthtech', path: 'healthtech',icon: '/assets/services/explore-more-services/web-dev.svg'},
    { name: 'Fintech', path: 'fintech',icon: '/assets/services/explore-more-services/web-dev.svg' },
    { name: 'Insurtech', path: 'insurtech',icon: '/assets/services/explore-more-services/web-dev.svg' },
    { name: 'E-Commerce', path: 'ecommerce',icon: '/assets/services/explore-more-services/web-dev.svg' },
    { name: 'Ed-Tech', path: 'edtech',icon: '/assets/services/explore-more-services/web-dev.svg' },
    { name: 'Media & Entertainment', path: 'media-entertainment',icon: '/assets/services/explore-more-services/web-dev.svg' },
    { name: 'Hi-Tech', path: 'hitech',icon: '/assets/services/explore-more-services/web-dev.svg' }
  ];

  filteredIndustries: IndustryLink[] = [];
  private routerSubscription!: Subscription;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.filterIndustries();
    
    // Subscribe to router events to update the list if user clicks a link within this component
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.filterIndustries();
        window.scrollTo(0, 0);
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
  navigateToIndustry(path: string): void {
    this.router.navigate(['/industries', path]);
  }
  private filterIndustries(): void {
    const currentUrl = this.router.url;
    // Filter out the industry that matches the current URL
    this.filteredIndustries = this.allIndustries.filter(industry => 
      !currentUrl.includes(industry.path)
    );
  }
}